import { opt } from 'store/opt'
import { formatCurrency } from 'util/currency'

export type TsumInfoRaw = {
  articul?: string
  available?: number
  category_group?: string
  category_id: number
  category_name?: string
  color?: string
  offer_id: number
  price?: number
  season?: string
  updated_at?: string
}

export type ImageRaw = {
  url: string
}

export type ItemFull = {
  article?: string
  created_at?: string
  item_descr?: string
  brand_name?: string
  dress_category?: string
  dress_colors?: string
  external_item_id?: string
  images?: ImageRaw[]
  item_id: string
  item_sources_images: ImageRaw[]
  custom_item_fulldress: ImageRaw[]
  links?: string
  links_name?: string
  prices?: string
  product_name?: string
  tsum_data?: string | TsumInfoRaw
  dress_shape_type?: string
  combinations?: number
}

export type Item = {
  article: string | undefined
  created_at: string | undefined
  description: string | undefined
  brand_name: string | undefined
  dress_category: string | undefined
  dress_colors: string | undefined
  external_item_id: string | undefined
  images: string[]
  item_id: string
  links: string | undefined
  links_name: string | undefined
  prices: string | undefined
  product_name: string | undefined
  season: string | undefined
  dress_shape_type: string | undefined
  dress_gender: string | undefined
  combinations: number | undefined
  collection_id: string | undefined
}

export type Items = {
  count: number
  items: Item[]
}

export function formatPrice(prices: string | null | undefined): string | undefined {
  const [currency, price] = prices?.split(':') ?? []
  return formatCurrency(price, currency)
}

export function buildBuyLink(links: string | undefined): string {
  if (!links) return ''
  try {
    const url = new URL(links)
    const utm = new URLSearchParams(opt.utm_buy)
    for (const [name, value] of utm) {
      url.searchParams.append(name, value)
    }
    return url.toString()
  } catch {
    return links
  }
}
